module.exports = __webpack_public_path__ + "img/Forget password_progress bar4.3388c491.png";